export const CHARACTER_DELETE_CONFIRM_TEXT: string =
  "Are you sure you want to delete character";

export const CHARACTER_DELETE_CONFIRM_TITLE: string = "Character";

export const CHARACTER_FILE_DELETE_CONFIRM_TEXT: string =
  "Are you sure you want to delete character file";

export const CHARACTER_FILE_DELETE_CONFIRM_TITLE: string = "Character file";
